export type ReactAriaTourLayer = {
  shouldCloseOnInteractOutside: (target: Element) => boolean;
  subscribeDropdownActive: (listener: (active: boolean) => void) => () => void;
};

let reactAriaTourLayer: ReactAriaTourLayer | null = null;
const listeners = new Set<() => void>();

export const registerReactAriaTourLayer = (
  layer: ReactAriaTourLayer | null,
): void => {
  reactAriaTourLayer = layer;
  listeners.forEach(listener => listener());
};

export const getReactAriaTourLayer = (): ReactAriaTourLayer | null =>
  reactAriaTourLayer;

export const subscribeReactAriaTourLayer = (
  listener: () => void,
): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
